import React from 'react';
import PropTypes from 'prop-types';

class MonthlyToAnnual extends React.Component {
    render() {
        let planName = this.props.isPlusUser() ? 'Plus' : 'Pro',
            mainCopy = (this.props.planAddOns || this.props.planTweets) ? `One year of ${planName} with your current add ons for $${this.props.planTotal}` : `One year of ${planName} for just $${this.props.promo.price}`;

        return (
            <div className="promo-content">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <h1 className="main-copy">
                    {mainCopy}
                </h1>
                <div className="sub-copy">
                    Lock in our best available price for your plan. Limited time offer.
                </div>
                <button type="button" className="promo-action-button" onClick={this.props.onRedeemPromoClick}>
                    {this.props.isWorking ? (
                        <span>
                            <i className="fa fa-spinner fa-spin" role="img" aria-label="Loading"></i>
                        </span>
                    ) : 'Get our best price'}
                </button>
                <div className="last-chance">
                    {`Move to the annual plan and get 12 months for just $${this.props.planTotal} today`}
                </div>
                <div className="coming-soon">
                    <h3>Hands-Free Social Media Publishing</h3>
                    <div className="feature-list">
                        {this.props.features.map((feature, i) => {
                            return (
                                <div key={`feature-${i}`} className="feature-detail">
                                    <div className="feature-image">
                                        <img src={feature.image}/>
                                    </div>
                                    <div className="feature-name">
                                        {feature.label}
                                    </div>
                                    <div className="feature-desc">
                                        {feature.description}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

MonthlyToAnnual.displayName = "MonthlyToAnnual";

MonthlyToAnnual.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.object
    ]),
    promo: PropTypes.object,
    onRedeemPromoClick: PropTypes.func,
    features: PropTypes.array,
    planAddOns: PropTypes.number,
    planTweets: PropTypes.number,
    planTotal: PropTypes.number.isRequired,
    isWorking: PropTypes.bool
};

MonthlyToAnnual.defaultProps = {
    image: null,
    promo: null,
    onRedeemPromoClick: () => {},
    features: [],
    planAddOns: 0,
    planTweets: 0,
    isWorking: false
};

export default MonthlyToAnnual;
